var render = function () {
  var _vm$latestTransaction, _vm$latestTransaction2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "top_info_container transactions"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Latest transaction")]), _c('p', {
    staticClass: "content"
  }, [_vm.latestTransaction ? _c('span', [_vm._v(" " + _vm._s(_vm.shortenText((_vm$latestTransaction = _vm.latestTransaction) === null || _vm$latestTransaction === void 0 ? void 0 : _vm$latestTransaction.hash, 4)) + " ")]) : _c('span', [_vm._v(" N/A ")])]), _c('p', {
    staticClass: "description"
  }, [_vm.latestTransaction ? _c('span', [_vm._v(" " + _vm._s(_vm._f("fromNow")((_vm$latestTransaction2 = _vm.latestTransaction) === null || _vm$latestTransaction2 === void 0 ? void 0 : _vm$latestTransaction2.createdAt)) + " ")]) : _c('span', [_vm._v("N/A")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }